module.exports = __webpack_public_path__ + "static/media/logo-pin-grey.33581b76.svg";